module.exports = __webpack_public_path__ + "public/img/Pelayanan Prima untuk Penjaga Toko.ee6ecaf1.png";